export enum EButtonType {
  Follow,
  Invite,
  Block,
  Select,
  Mute,
  None,
}
